import { CapacityReportStatus } from '@libs/services/graphql/generated/ala-backend.service';
import { Expose, Transform } from 'class-transformer';

export class CapacityReportingDto {
  @Expose() id!: string;

  @Expose() facilityName!: string;

  @Expose() status!: CapacityReportStatus;

  @Expose() hasEarlierIncompleteReports!: boolean;

  @Expose()
  @Transform(({ value }) => new Date(value))
  capacityReportPeriodDueDate!: Date;

  @Expose()
  @Transform(({ value }) => (value ? new Date(value) : undefined))
  submittedAt?: Date;

  @Expose()
  submittedByName?: string;
}
